const EUR = (v) => (Number(v) || 0).toLocaleString("pt-PT", { style: "currency", currency: "EUR" });

function StatBox({ label, value, highlight }) {
  const color =
    highlight === "pos" ? "text-green-700"
      : highlight === "neg" ? "text-red-600"
        : "text-[#0F1829]";
  return (
    <div className="px-3 py-2 bg-white border border-[#E6E1D6] rounded">
      <div className="text-[9px] uppercase tracking-[0.15em] text-[#978D78] font-bold">{label}</div>
      <div className={`font-mono text-sm mt-0.5 ${color}`}>{value}</div>
    </div>
  );
}

function highlightForPorPagar(porPagar) {
  if (porPagar > 0) return "pos";
  if (porPagar < 0) return "neg";
  return null;
}

export default function PaymentPositionStats({ position, fallback }) {
  const pos = position || fallback || {};
  const porPagar = Number(pos.PorPagar || 0);
  const disponivel = Number(pos.DisponivelPagamento || 0);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs">
      <StatBox label="Total Ganhas" value={EUR(pos.ValorTotal ?? pos.Ganhas)} />
      <StatBox label="Já Pago" value={EUR(pos.ValorPago ?? pos.Pagas)} />
      <StatBox label="Por Pagar" value={EUR(porPagar)} highlight={highlightForPorPagar(porPagar)} />
      <StatBox label="Disponível" value={EUR(disponivel)} />
    </div>
  );
}
